module.exports = __webpack_public_path__ + "static/media/joel-trzcinski.9f6f2959.jpg";